import ScrollToTop from '@/components/base/ScrollToTop';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SchemaOrg from '@/components/feature/SchemaOrg';
import HeroSection from './components/HeroSection';
import FeaturedVideos from './components/FeaturedVideos';
import CategorySection from './components/CategorySection';
import StatsSection from './components/StatsSection';
import FAQSection from './components/FAQSection';

export default function Home() {
  const websiteSchema = {
    name: '蘑菇视频在线观看',
    url: 'https://moguvideo.cn',
    description: '蘑菇视频在线观看平台，汇聚海量高清视频资源，无需下载即可流畅在线观看。支持多终端、多分辨率，随时随地畅享精彩内容。',
    potentialAction: {
      '@type': 'SearchAction',
      'target': {
        '@type': 'EntryPoint',
        'urlTemplate': 'https://moguvideo.cn/search?q={search_term_string}',
      },
      'query-input': 'required name=search_term_string',
    },
    inLanguage: 'zh-CN',
  };

  const orgSchema = {
    name: '蘑菇视频在线观看',
    url: 'https://moguvideo.cn',
    logo: 'https://moguvideo.cn/logo.png',
    description: '国内领先的免费高清在线视频平台',
    foundingDate: '2018',
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: '+86-400-888-6666',
      contactType: 'customer service',
      availableLanguage: ['Chinese'],
    },
    sameAs: [
      'https://weibo.com/moguvideo',
      'https://space.bilibili.com/moguvideo',
    ],
  };

  const faqSchema = {
    mainEntity: [
      {
        '@type': 'Question',
        name: '蘑菇视频在线观看需要下载App吗？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '不需要！蘑菇视频在线观看是完全基于浏览器的在线视频平台，您无需下载任何App或插件，打开浏览器即可随时随地畅享高清视频内容。',
        },
      },
      {
        '@type': 'Question',
        name: '蘑菇视频在线观看是否完全免费？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '是的，蘑菇视频在线观看平台的核心视频内容完全免费向所有用户开放。',
        },
      },
      {
        '@type': 'Question',
        name: '如何在手机上观看蘑菇视频？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '蘑菇视频在线观看支持多终端访问，您可以在手机浏览器中直接打开我们的网站，体验专为移动端优化的响应式界面。',
        },
      },
      {
        '@type': 'Question',
        name: '蘑菇视频的内容多久更新一次？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '蘑菇视频在线观看平台每日更新海量内容，涵盖纪录片、科技、影视、教育、美食、旅游等多个领域。',
        },
      },
      {
        '@type': 'Question',
        name: '蘑菇视频支持哪些设备？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '蘑菇视频在线观看平台全面支持PC电脑、平板、智能手机等多种设备，采用响应式设计，支持投屏功能。',
        },
      },
      {
        '@type': 'Question',
        name: '蘑菇视频支持哪些分辨率播放？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '蘑菇视频在线观看平台支持多种分辨率选择，包括720P高清、1080P全高清、4K超高清以及部分精选内容的8K极清画质。',
        },
      },
    ],
  };

  return (
    <>
      <ScrollToTop />
      <SchemaOrg type="WebSite" data={websiteSchema} />
      <SchemaOrg type="Organization" data={orgSchema} />
      <SchemaOrg type="FAQPage" data={faqSchema} />
      <Navbar />
      <main>
        <HeroSection />
        <FeaturedVideos />
        <CategorySection />
        <StatsSection />
        <FAQSection />
      </main>
      <Footer />
    </>
  );
}